/**
 * Generated bundle index. Do not edit.
 */
export * from './main';



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-pdf-export/dist/es/index.js
// module id = ../../../../@progress/kendo-angular-pdf-export/dist/es/index.js
// module chunks = vendor